import ProductPage from "../../components/ProductPage";
import { capitalGainBondsData } from "../../data/productsData";
export default function CapitalGainBonds() { return <ProductPage data={capitalGainBondsData} />; }